import { z } from "zod";

export const buildingCodeSchema = z
  .string()
  .trim()
  .toUpperCase()
  .regex(/^[A-Z0-9]{2,8}$/, "2–8 tekens, A-Z en 0-9");

export const pad = (n: number, l = 4): string => String(n).padStart(l, "0");

/** `W455-0007` */
export const issueCode = (buildingCode: string, seq: number): string => `${buildingCode}-${pad(seq)}`;
/** `T-0001` */
export const taskCode = (seq: number): string => `T-${pad(seq)}`;
/** Op de pin: volgnummer zonder voorloopnullen. */
export const pinLabel = (seq: number): string => String(seq);

/**
 * Tekens van een assetcode: geen klinkers (dus geen woorden) en geen tekens die op elkaar lijken
 * (0/O, 1/I/L, 5/S, Q).
 */
export const ASSET_CODE_CHARS = "BCDFGHJKMNPRTVWXYZ23456789";
/** Combinaties die we niet op een label willen, ook zonder klinkers. */
const ASSET_CODE_BLOCKED = ["KKK", "PKK", "GVD", "PVV", "FCK", "WTF", "KNT", "88"];
/** Assetcode `B6Y-7CG`; een onderdeel heeft de code van de hoofdasset met `.1`, `.2`, … */
export const ASSET_CODE_RE = /^[A-Z0-9]{3}-[A-Z0-9]{3}$/;

// Web Crypto bestaat in de browser en in Node 22; shared heeft geen DOM- of Node-typen.
const webCrypto = (globalThis as unknown as { crypto: { getRandomValues<T extends Uint8Array>(a: T): T } }).crypto;

/**
 * Kentekenachtige assetcode `B6Y-7CG`, willekeurig in plaats van een volgnummer, zodat een later
 * geplakt label niet opvalt en de code niet aan het gebouw hangt. 26^6 ≈ 309 miljoen codes.
 */
export function randomAssetCode(): string {
  const n = ASSET_CODE_CHARS.length;
  const limit = 256 - (256 % n);
  for (;;) {
    let s = "";
    while (s.length < 6) {
      for (const byte of webCrypto.getRandomValues(new Uint8Array(16))) {
        if (byte < limit && s.length < 6) s += ASSET_CODE_CHARS[byte % n];
      }
    }
    if (!ASSET_CODE_BLOCKED.some((w) => s.includes(w))) return `${s.slice(0, 3)}-${s.slice(3)}`;
  }
}
